import { colors } from 'constants/colors';
import React from 'react';
import styled from '@emotion/styled';
export default (props) => {
    const { isError, text } = props;
    return React.createElement(Heading, { isError: isError }, text);
};
const Heading = styled.div `
  margin: 0 0 24px;
  font-size: 40px;
  font-weight: 500;
  line-height: 1.3;
  text-align: center;
  color: ${(props) => (props.isError ? colors.ff676e : colors[405766])};
`;
